export default "__VITE_ASSET__f1b9cfb1__"